<template>
  <!-- 空运/海运(装柜)列表 -->
  <div class="container">
    <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="出库配载列表" name="first">
        <!-- 按钮列表 -->
        <div class="glo_btnList" ref="btnList">
          <div class="glo_btnList_left">
            <el-button class="glo_btnItems glo_bgcMainColor" @click="AddBtns()"
            >新建</el-button
            >
            <el-button class="glo_btnItems glo_bgcMainColor" @click="ModifyBtns()"
            >修改</el-button>
            <el-button plain class="jy-button" @click="onVisitLoadingDetails('readonly')"
            >查看</el-button
            >
            <el-button plain class="jy-button" @click="onOutbound('confirm')"
            >出库确认</el-button
            >
            <el-button plain class="jy-button" @click="onOutbound('cancel')"
            >取消出库</el-button
            >
            <el-button plain class="jy-button" @click="onDiaCustomerService"
            >客服跟踪</el-button
            >
            <el-button plain class="jy-button"  @click="onDeleteBillEntruck"
            >删除</el-button
            >
            <el-button class="jy-button " @click="myModel"
            >表格设置</el-button
            >
            <template >
              <div class="tableExportBtn">
                <exportTb
                    :theadData="myTableHeard"
                    :tableData="tableData"
                    :resultData="tableData"
                    @handleExportDia_dc="handleExportDia_dc('空运海运出库')"
                ></exportTb>
              </div>
            </template>
            <!--        <el-button plain :disabled="mainID === ''" class="jy-button"-->
            <!--        >打印拣货单</el-button-->
            <!--        >-->

            <!-- <el-dropdown class="topDropDown" @command="topCommandBtns">
              <el-button type="primary">
                更多操作
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="dtdc">导出</el-dropdown-item>
                <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
          </div>
          <queryBtns
              :MoreConditions="MoreConditions"
              @clerBtns="clerBtns"
              @queryBtn_ok="queryBtn_ok"
              @moreParam="moreParam"
          ></queryBtns>
        </div>
        <!-- 查询条件 -->
        <!-- :formData="queryData" -->
        <queryCondition
            ref="queryForm"
            :More="isHaseMore"
            :formConfig="queryCondditionDatas"
        ></queryCondition>
        <!-- 表格 -->
        <div class="glo_Table">
          <el-table
              :height="tableHeigth"
              header-align="center"
              ref="mytable"
              @row-click="rowclick"
              :data="tableData"
              border
              stripe
              :highlight-current-row="true"
              show-summary
              :summary-method="getSummaries"
              @selection-change="handleSelectionChange"
          >
            <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
            ></el-table-column>
            <el-table-column
                fixed="left"
                align="center"
                type="selection"
                width="60"
            ></el-table-column>
            <template v-for="(item, index) in myTableHeard">
              <!-- 某个字段需要单独操作  例如点击可以跳转 -->
              <el-table-column
                  v-if="item.field === 'aaaaaaaaaa' && item.isShow"
                  :key="index"
                  :label="item.name"
                  :prop="item.field"
                  align="left"
                  sortable
                  :show-overflow-tooltip="true"
                  :min-width="item.width"
                  :data-isTotal="item.isTotal"
              >
                <template slot-scope="scope">
                  <div class="linkTabel">
                    {{ scope.row.aaaaaaaaaa }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  :key="index"
                  :label="item.name"
                  :prop="item.field"
                  align="center"
                  sortable
                  :show-overflow-tooltip="true"
                  :min-width="item.width"
                  :data-isTotal="item.isTotal"
                  v-else-if="item && item.isShow"
              ></el-table-column>
            </template>
            <!--        <el-table-column fixed="right" label="操作" min-width="180px">-->
            <!--          <template slot-scope="scope">-->
            <!--            <div class="tabRightBtns">-->
            <!--              <el-button class="rbtns" @click.stop="ModifyBtns(scope.row)"-->
            <!--                >修改</el-button-->
            <!--              >-->
            <!--              <el-button class="rbtns" @click.stop="onVisitLoadingDetails(scope.row)"-->
            <!--                >详情</el-button-->
            <!--              >-->
            <!--              <el-button class="rbtns" @click.stop="delCouponBtns(scope.row)"-->
            <!--                >作废</el-button-->
            <!--              >-->
            <!--              &lt;!&ndash; 如果按钮超过4个就要用下面这种下拉的样式 &ndash;&gt;-->
            <!--              &lt;!&ndash; <el-dropdown-->
            <!--                  class="rbtns"-->
            <!--                  @command="handleCommandBtns($event, scope.row)"-->
            <!--                >-->
            <!--                  <el-button type="primary">-->
            <!--                    更多操作<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
            <!--                  </el-button>-->
            <!--                  <el-dropdown-menu slot="dropdown">-->
            <!--                    <el-dropdown-item command="a">详情</el-dropdown-item>-->
            <!--                    <el-dropdown-item command="b">外发录入</el-dropdown-item>-->
            <!--                    <el-dropdown-item command="c">改运单号</el-dropdown-item>-->
            <!--                    <el-dropdown-item command="d">删除</el-dropdown-item>-->
            <!--                  </el-dropdown-menu>-->
            <!--                </el-dropdown>&ndash;&gt;-->
            <!--            </div>-->
            <!--          </template>-->
            <!--        </el-table-column>-->
          </el-table>
        </div>

        <!-- 分页 -->
        <paging
            ref="pags"
            :pageNum="pageStart"
            :total="pageCount"
            :size="pageTotal"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
        ></paging>

      </el-tab-pane>

      <el-tab-pane label="出库配载明细列表" name="second">
        <!-- 按钮列表 -->
        <div class="glo_btnList" ref="btnList">
          <div class="glo_btnList_left">
            <el-button class="jy-button " @click="myModel"
            >表格设置</el-button
            >
            <!--        <el-button plain :disabled="mainID === ''" class="jy-button"-->
            <!--        >打印拣货单</el-button-->
            <!--        >-->

            <!-- <el-dropdown class="topDropDown" @command="topCommandBtns">
              <el-button type="primary">
                更多操作
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="dtdc">导出</el-dropdown-item>
                <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
            <template >
              <div class="tableExportBtn">
                <exportTb
                    :theadData="myTableHeard"
                    :tableData="tableData"
                    :resultData="tableData"
                    @handleExportDia_dc="handleExportDia_dc('空运海运出库明细')"
                ></exportTb>
              </div>
            </template>
          </div>
          <queryBtns
              :MoreConditions="MoreConditions"
              @clerBtns="clerBtns"
              @queryBtn_ok="queryBtn_ok"
              @moreParam="moreParam"
          ></queryBtns>
        </div>
        <queryCondition
            ref="queryForm"
            :More="isHaseMore"
            :formConfig="queryCondditionDatas"
        ></queryCondition>
        <!-- 表格 -->
        <div class="glo_Table">
          <el-table
              :height="tableHeigth"
              header-align="center"
              ref="mytable"
              @row-click="rowclick"
              :data="tableData"
              border
              stripe
              :highlight-current-row="true"
              show-summary
              :summary-method="getSummaries"
              @selection-change="handleSelectionChange"
          >
            <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
            ></el-table-column>
            <el-table-column
                fixed="left"
                align="center"
                type="selection"
                width="60"
            ></el-table-column>
            <template v-for="(item, index) in myTableHeard">
              <!-- 某个字段需要单独操作  例如点击可以跳转 -->
              <el-table-column
                  v-if="item.field === 'aaaaaaaaaa' && item.isShow"
                  :key="index"
                  :label="item.name"
                  :prop="item.field"
                  align="left"
                  sortable
                  :show-overflow-tooltip="true"
                  :min-width="item.width"
                  :data-isTotal="item.isTotal"
              >
                <template slot-scope="scope">
                  <div class="linkTabel">
                    {{ scope.row.aaaaaaaaaa }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  :key="index"
                  :label="item.name"
                  :prop="item.field"
                  align="center"
                  sortable
                  :show-overflow-tooltip="true"
                  :min-width="item.width"
                  :data-isTotal="item.isTotal"
                  v-else-if="item && item.isShow"
              ></el-table-column>
            </template>
            <!--        <el-table-column fixed="right" label="操作" min-width="180px">-->
            <!--          <template slot-scope="scope">-->
            <!--            <div class="tabRightBtns">-->
            <!--              <el-button class="rbtns" @click.stop="ModifyBtns(scope.row)"-->
            <!--                >修改</el-button-->
            <!--              >-->
            <!--              <el-button class="rbtns" @click.stop="onVisitLoadingDetails(scope.row)"-->
            <!--                >详情</el-button-->
            <!--              >-->
            <!--              <el-button class="rbtns" @click.stop="delCouponBtns(scope.row)"-->
            <!--                >作废</el-button-->
            <!--              >-->
            <!--              &lt;!&ndash; 如果按钮超过4个就要用下面这种下拉的样式 &ndash;&gt;-->
            <!--              &lt;!&ndash; <el-dropdown-->
            <!--                  class="rbtns"-->
            <!--                  @command="handleCommandBtns($event, scope.row)"-->
            <!--                >-->
            <!--                  <el-button type="primary">-->
            <!--                    更多操作<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
            <!--                  </el-button>-->
            <!--                  <el-dropdown-menu slot="dropdown">-->
            <!--                    <el-dropdown-item command="a">详情</el-dropdown-item>-->
            <!--                    <el-dropdown-item command="b">外发录入</el-dropdown-item>-->
            <!--                    <el-dropdown-item command="c">改运单号</el-dropdown-item>-->
            <!--                    <el-dropdown-item command="d">删除</el-dropdown-item>-->
            <!--                  </el-dropdown-menu>-->
            <!--                </el-dropdown>&ndash;&gt;-->
            <!--            </div>-->
            <!--          </template>-->
            <!--        </el-table-column>-->
          </el-table>
        </div>

        <!-- 分页 -->
        <paging
            ref="pags"
            :pageNum="pageStart"
            :total="pageCount"
            :size="pageTotal"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
        ></paging>
      </el-tab-pane>
    </el-tabs>

    <!--  客服跟踪-->
    <customerModelService
        :show="customerModelServiceStatus"
        :documentNumbers="[]"
        documentStatus="bill_tms_entruck_v3:document_status"
        @onCancelCustomerService="onCancelCustomerService"
        @onConfirmCustomerService="onConfirmCustomerService"
        pageType="/pages/v4/entruck/entruckDetails"
        :dataList="dataList"
    >
    </customerModelService>
    <!--        自定义表头           -->
    <sorttable
        :show_sortTableHeard="show_sortTableHeard"
        :allCheck="allCheck"
        :sortName="sortName"
        :tabelHeadeTitle="tabelHeadeTitle"
        :originalTabelHeadeTitle="originalTabelHeadeTitle"
        :selectLength="selectLength"
        @cancelSortHeard="cancelSortHeard"
        @confirmOk="confirmOk"
        @checktab="checktab"
        @checkAll="checkAll"
        @closeDias="closeDias"
    ></sorttable>

    <!-- 导出插件 -->
    <exportComponent
        :isShowDialog_dc="exportForm.isShowDialog_dc"
        :diaWidth_dc="exportForm.diaWidth_dc"
        :diaHeight_dc="exportForm.diaHeight_dc"
        :dialogTitle="exportForm.dialogTitle"
        :dialogForm_dc="exportForm.dialogForm_dc"
        :data="exportForm.queryForm"
        :tableHeard="exportForm.EPtableHeard"
        :AllCheck="exportForm.EPAllCheck"
        @checktabEP="checktabEP"
        @checkAllEP="checkAllEP"
        @onAfterEnter="onAfterEnter"
        @handleCloseDia_dc="handleCloseDia_dc"
        @diaConfirmBtn_dc="diaConfirmBtn_dc"
        queryType="exportModeList"
    >
    </exportComponent>
  </div>
</template>
  <script>
import tableList from "@/pages/DynamicList/tableList.js";
//   import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtnsDT.vue";
import queryCondition from "@/components/queryCondition.vue";
import myDialog from "@/components/DialogDT.vue";
import { Message as ElMessage, MessageBox as ElMessageBox } from 'element-ui'
import utils from "@/assets/js/tool";
//   import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import customerModelService from "@/components/customerService/modelIndex.vue";
import { Api } from "@/assets/js/api";
import exportTb from "@/components/exportComponent/exportTb.vue";
import tableListNew from "@/pages/tableListNew.js";
import exportComponent from "@/components/exportComponent/index.vue";
import sorttable from "@/components/sortTemplate.vue"; //mixins 查询列表页公共方法
export default {
  mixins: [tableList,tableListNew],
  inject: ["reload"],
  components: {
    sorttable,
    exportComponent,
    exportTb,
    //   sorttable,
    paging,
    queryBtns,
    queryCondition,
    myDialog,
    customerModelService,
  },
  data() {
    return {
      sortName:  "空运海运出库列表",
      userList: [],

      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "空运海运出库列表", //导出时默认文件名
        apiName: "/v1/common/query/runPageReport", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd===等待下载完成,bdd===不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "DynamicListEntruckList", //  页面标识
      reportFiledsNumber: "bill_entruck_list", // 动态 条件、表头
      pageGroupNameMap: {
        first: "DynamicListEntruckList", //
        second: "DynamicListEntruckMxList" //
      },
      currentItemArr: [],
      dialogType: "",
      showTimers:false,
      dataList: [],
      oneDocuNumber: "",
      customerModelServiceStatus: false,
      activeName: "first",
      tabCache: {
        first: {
          queryData: {},
          tableData: [],
          queryCondditionDatas: [],
          tableHeader: []  // 添加这个字段
        },
        second: {
          queryData: {},
          tableData: [],
          queryCondditionDatas: [],
          tableHeader: []  // 添加这个字段
        }
      },
      currentTab: 'first',
    };
  },
  mounted() {
    // 触发查询
    this.getData();
  },
  watch: {},
  methods: {
    //新增柜单
    AddBtns(){
      this.$router.push({
        path: "/pages/v4/entruck/entruckAdd",
        query: {
          pageType: "create",
        }
      });
    },
    //修改柜单
    ModifyBtns(row){
      let list = this.currentItemArr || [];
      if (row) {
        list = [row];
      }
      if (list.length === 1) {
        this.$router.push({
          path: "/pages/v4/entruck/editEntruck",
          query: {
            pageType: "modify",
            entruckId: list[0].entruckId,
          },
        });
      }else{
        this.$message.error("请选择1条数据");
        return false;
      }

    },
    // 表格选择事件
    handleSelectionChange(e) {
      this.currentItemArr = e || [];
    },

    // 不能输入负数
    minNum(val) {
      return val < 0 ? 0 : val;
    },
    //查看柜单详情
    onVisitLoadingDetails(type, data){
      var list = this.currentItemArr || [];
      if (data) {
        list = [data];
      }
      console.log("list", list);
      if (list.length === 1) {
        let obj = {
          status: type,
          id: list[0].entruckId,
          tagTitle: "查看出库详情",
        };
        this.$router.push({
          path: "/pages/v4/entruck/entruckDetails",
          query: obj
        });
      } else {
        ElMessage({
          message: "请选择1条表格数据",
          type: "warning",
        });
      }
    },

    async onOutbound(status){
      if (this.currentItemArr.length < 1) {
        ElMessage({
          message: "请选择单据",
          type: "error",
        });
        return false;
      }
      const idList = this.currentItemArr.map((item) => {
        return item.entruckId;
      });
      let params = {
        entruckId: idList,
      };
      if (status === "confirm") {
        ElMessageBox.confirm("是否对该单据进行出库确认？", "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(async () => {
              await Api.confirmOutStorage(params).then((res) => {
                if (res.status === 200) {
                  const data = res.data;
                  if (utils.jyCheckObjectType(data) === "Object") {
                    ElMessage({
                      message: data.message,
                      type: data.status,
                    });
                    let that = this;
                    setTimeout(() => {
                      that.queryBtn_ok();
                    }, 500);
                  }
                }
              });

            })
            .catch(() => {});
      } else {
        ElMessageBox.confirm("是否对所选数据进行取消出库？", "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(async () => {
              await Api.cancelOutStorage(params).then((res) => {
                if (res.status === 200) {
                  const data = res.data;
                  if (utils.jyCheckObjectType(data) === "Object") {
                    ElMessage({
                      message: data.message,
                      type: data.status,
                    });
                    let that = this;
                    setTimeout(() => {
                      that.queryBtn_ok();
                    }, 500);
                  }
                }
              });
            })
            .catch(() => {});
      }
    },

    async onDiaCustomerService(){
      if (this.currentItemArr.length < 1) {
        ElMessage({
          message: "请选择单据",
          type: "error",
        });
        return false;
      }
      this.dataList = this.currentItemArr;

      this.currentItemArr.forEach((item) => {
        this.oneDocuNumber = item.number;
      });
      this.customerModelServiceStatus = true;


    },
    onCancelCustomerService () {
      this.customerModelServiceStatus = false;
    },

    onConfirmCustomerService (obj) {
      this.customerModelServiceStatus = false;

    },
    //删除装柜配载单
    async onDeleteBillEntruck (){
      if (this.currentItemArr.length >= 1) {
        ElMessageBox.confirm("是否删除所选数据？", "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(async () => {
              const idList = this.currentItemArr.map((item) => {
                return item.entruckId;
              });
              let params = {
                entruckId: idList,
              };
              await Api.deleteBillEntruck(params).then((res) => {
                if (res.status === 200) {
                  const data = res.data;
                  if (utils.jyCheckObjectType(data) === "Object") {
                    ElMessage({
                      message: "删除成功",
                      type: data.status,
                    });
                    let that = this;
                    setTimeout(() => {
                      that.queryBtn_ok();
                    }, 500);
                  }
                }
              });
            })
            .catch(() => {});
      } else {
        ElMessage({
          message: "请选择表格数据",
          type: "warning",
        });
      }
    },
    handleClick(tab, event) {
      // 保存当前 tab 的状态
      if (this.activeName && this.$refs.queryForm) {
        const currentFormData = this.$refs.queryForm.getFormData ?
            this.$refs.queryForm.getFormData() :
            this.$refs.queryForm.formData;

        if (!this.tabCache) {
          this.tabCache = {
            first: {},
            second: {}
          };
        }

        // 缓存当前 tab 的数据
        this.tabCache[this.activeName] = {
          ...this.tabCache[this.activeName],
          queryData: currentFormData,
          pageStart: this.pageStart
        };
      }

      // 切换 tab
      this.activeName = tab.name;
      let rqNumber = "bill_entruck_list";
      this.sortName = "空运海运出库列表";
      this.pageGroupName = this.pageGroupNameMap[tab.name];
      if (tab.name === "second") {
        this.mxSearchHeight = this.mxSearchHeight > 86 ? this.mxSearchHeight : 86;
        rqNumber = "pageArriveEntruck_detail";
        this.sortName = "出库配载明细";
      }

      // 初始化目标 tab
      this.initTableByTab(tab.name, rqNumber);
    },
  },




};
</script>
  <style scoped lang="scss">
::v-deep .el-date-editor.el-input {
  width: auto !important;
}

.classA {
  display: flex;
}

.glo_dialogForm .diaForm .dialogFormItems {
  height: 30px !important;
  line-height: 30px !important;
  overflow: hidden;
}

.couponBox {
  width: 100%;
  margin-bottom: 20px;
  height: 34px;

  .couponitmeInput {
    width: 100px;
    border: 1px solid #cccccc;
    margin: 0 6px;

    ::v-deep .el-input__inner {
      height: 30px;
      line-height: 30px;
    }
  }

  .couponItemA {
    display: flex;
    align-items: center;
  }
}

.displays {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.rows {
  display: flex;
  width: 100%;
}

.multipleSelect {
  ::v-deep .el-select {
    border: 1px solid #cccccc;
    border-radius: 4px;
  }
}
</style>
  